


































































import Vue from 'vue';
import { Prop } from 'vue/types/options';

export default Vue.extend({
  computed: {
    isDisabled(): boolean {
      return this.readonly && !this.isFocused;
    },
  },
  data() {
    return {
      internalType: this.type === 'date' ? 'tel' : this.type, // Hack: Disable browser masks
      isFocused: false,
      tokens: {
        '#': { pattern: /\d/ },
        '^': { pattern: /[\d●]/ },
        X: { pattern: /[0-9a-zA-Z]/ },
        S: { pattern: /[a-zA-Z]/ },
        A: { pattern: /[a-zA-Z]/, transform: v => v.toLocaleUpperCase() },
        a: { pattern: /[a-zA-Z]/, transform: v => v.toLocaleLowerCase() },
        '!': { escape: true },
      },
      $_veeValidate: {
        value: () => {
          return this.value;
        },
        name: () => {
          return this.label || this.name;
        },
      },
    };
  },
  inheritAttrs: false,
  methods: {
    activateInput() {
      if ((this.$refs.input as Vue).$el) {
        ((this.$refs.input as Vue).$el as HTMLInputElement).focus();
      } else if ((this as any).$refs.input) {
        (this as any).$refs.input.focus();
      }
    },
    onBlur() {
      this.$data.isFocused = false;
      this.$emit('blur');
    },
    onFocus() {
      this.$data.isFocused = true;
      this.$emit('focus');
    },
    handleInput(value) {
      this.$emit('input', value);
    },
  },
  props: {
    autocomplete: {
      default: '',
      type: String,
    },
    label: {
      required: true,
      type: String as Prop<string | undefined>,
    },
    name: {
      required: true,
      type: String,
    },
    pattern: {
      type: String,
      default: undefined,
    },
    placeholder: {
      type: String,
      default: undefined,
    },
    readonly: {
      default: false,
      type: Boolean,
    },
    required: {
      default: false,
      type: Boolean,
    },
    type: {
      default: '',
      type: String,
    },
    validator: {
      default() {
        return val => !!val;
      },
      type: (Function as unknown) as Prop<() => boolean>,
    },
    value: {
      default: '',
    },
    isValid: {
      type: Boolean,
      default: true,
    },
    mask: {
      type: String,
      default: '',
    },
    masked: {
      type: Boolean,
      default: false,
    },
  },
});
